export default __webpack_public_path__ + "static/media/patrimonio.97daaccd.png";